import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';

export interface Section {
  name: string;
  id: string;
  subSections?: Section[];
}

@Component({
    selector: 'jump-to-section',
    templateUrl: './jump-to-section.component.html',
    styleUrls: ['./jump-to-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JumpToSectionComponent {
  @Input('sections') sections: Section[];
  public selected: string = '';
  jumpTo($event: MatSelectChange) {
    setTimeout(() => {
      if ($event.value?.length) {
        let el = document.getElementById($event.value);
        el?.scrollIntoView({ behavior: 'smooth' });
        this.selected = '';
      }
    }, 5);
  }
}
